export const KEYBOARD_CLOSE_REASONS = ['escapeKeyDown', 'tabKeyDown'];
